import {
  arrayRemove,
  arrayUnion,
  doc,
  getDoc,
  updateDoc,
} from "firebase/firestore";
import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { db, auth } from "../firebaseconfig/firebase";
import {
  collection,
  addDoc,
  query,
  where,
  onSnapshot,
  orderBy,
  serverTimestamp,
  setDoc,
} from "firebase/firestore";
import { AiFillLike } from "react-icons/ai";

const BlogDescription = ({ isAuth }) => {
  const [getBlogs, setGetBlogs] = useState();
  const [commentText, setCommentText] = useState("");
  const [comments, setComments] = useState([]);
  const [replyingTo, setReplyingTo] = useState(null);
  const [replyText, setReplyText] = useState("");

  const navigate = useNavigate();
  const params = useParams();

  const getAllBlogs = async () => {
    try {
      const blogsnap = await getDoc(doc(db, "Posts", params.id));
      if (blogsnap.exists()) {
        setGetBlogs(blogsnap.data());
      } else {
        console.log("Document does not exist");
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getAllBlogs();
    if (!isAuth) {
      navigate("/");
    }
  });

  useEffect(() => {
    if (!params.id) return;

    const q = query(
      collection(db, "Comments"),
      where("postId", "==", params.id),
      orderBy("createdAt", "desc")
    );

    const unsubscribe = onSnapshot(q, (snapshot) => {
      const temp = [];
      snapshot.forEach((doc) => temp.push({ id: doc.id, ...doc.data() }));
      setComments(temp);
    });

    return () => unsubscribe();
  }, [params.id]);

  const handlePostComment = async () => {
    if (commentText.trim() === "") return alert("Comment cannot be empty");

    const commentRef = doc(collection(db, "Comments"));

    await setDoc(commentRef, {
      commentId: commentRef.id, 
      postId: params.id,
      userId: auth.currentUser?.uid || "guest",
      username: auth.currentUser?.displayName || "Anonymous User",
      avatar:
        auth.currentUser?.photoURL || "https://ui-avatars.com/api/?name=User",
      comment: commentText,
      createdAt: serverTimestamp(),
      likes: [],
      replies: [],
    });

    setCommentText("");
  };

  const handleLike = async (commentId, likes = []) => {
    const userId = auth.currentUser?.uid;

    if (!userId) return alert("You must be logged in to like comments");

    const hasLiked = (likes ?? []).includes(userId);

    const commentRef = doc(db, "Comments", commentId);

    await updateDoc(commentRef, {
      likes: hasLiked
        ? arrayRemove(userId) // remove like
        : arrayUnion(userId), // add like
    });
  };

  const handleReply = async (commentId, replyText) => {
    const userId = auth.currentUser?.uid;
    if (!userId) return alert("Login to reply");

    const commentRef = doc(db, "Comments", commentId);

    await updateDoc(commentRef, {
      replies: arrayUnion({
        replyText,
        userId,
        avatar:
          auth.currentUser?.photoURL || "https://ui-avatars.com/api/?name=User",
        username: auth.currentUser?.displayName || "Anonymous",
        createdAt: new Date().toISOString(), 
      }),
    });

    setReplyText("");
  };

  const getComments = () => {
    const q = query(
      collection(db, "Comments"),
      where("postId", "==", params.id)
    );

    onSnapshot(q, (snapshot) => {
      const commentsArray = snapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));

      setComments(commentsArray);
    });
  };

  return (
    <div className="bg-blue-950 min-h-screen">
      <div className=" max-w-3xl mx-auto px-4 py-10 flex flex-col gap-6">
        <p className="text-blue-600  uppercase tracking-wide font-semibold text-2xl">
          {getBlogs?.category}
        </p>

        <h1 className="text-3xl md:text-5xl font-bold leading-tight text-white">
          {getBlogs?.title}
        </h1>

        <div className="flex flex-wrap gap-2 text-gray-500 text-sm">
          <span>
            By:{" "}
            <span className="font-medium text-gray-700">
              {getBlogs?.author.name || "Anonymous"}
            </span>
          </span>
          <span>•</span>
          <span>Published on {getBlogs?.date}</span>
        </div>

        <img
          src={getBlogs?.thumbnail}
          alt="Blog Thumbnail"
          className="w-full h-auto rounded-xl object-cover shadow-lg"
        />

        <p className="text-lg leading-relaxed text-white whitespace-pre-line">
          {getBlogs?.postDescription}
        </p>

        <div className="border-t-2">
          <h3 className="text-white">Comments ({comments.length})</h3>
          <div>
            <textarea
              value={commentText}
              onChange={(e) => setCommentText(e.target.value)}
              placeholder="Write your Comment"
              className="w-full p-4 border border-gray-300 rounded-lg 
                  focus:outline-none focus:ring-2 focus:ring-blue-500 resize-none"
              size="22"
            />
            <button
              onClick={handlePostComment}
              className="m-4 self-end bg-blue-600 hover:bg-blue-700 text-white px-6 py-2 rounded-lg font-medium transition"
            >
              Post Comment
            </button>
          </div>
          <div className="flex flex-col gap-6">
            {/* {comments.map((item) => (
                    <div
                      key={item.id}
                      className="bg-gray-50 p-5 rounded-lg shadow-sm"
                    >
                      <div className="flex items-center gap-3">
                        <img
                          src={item.avatar}
                          alt="avatar"
                          className="w-12 h-12 rounded-full object-cover border"
                        />

                        <div>
                          <h5 className="font-semibold text-gray-900">
                            {item.name}
                          </h5>
                          <p className="text-gray-500 text-sm">
                            {item.createdAt?.toDate().toLocaleString()}
                          </p>
                        </div>
                      </div>

                      <p className="mt-3 text-gray-700 leading-relaxed">
                        {item.comment}
                      </p>
                    </div>
                  ))} */}
            <div className="flex flex-col gap-6">
              {comments.map((item) => (
                <div
                  key={item.commentId}
                  className="bg-gray-50 p-4 rounded-lg shadow-sm"
                >
                  <div className="flex items-center gap-3">
                    <img
                      src={item.avatar}
                      alt="avatar"
                      className="w-12 h-12 rounded-full object-cover border"
                    />

                    <div>
                      <h5 className="font-semibold text-gray-900">
                        {item.username}
                      </h5>
                      <p className="text-gray-500 text-sm">
                        {item.createdAt?.toDate().toLocaleString()}
                      </p>
                    </div>
                  </div>

                  <p className="mt-3 text-gray-700 leading-relaxed">
                    {item.comment}
                  </p>

                  <div className="flex items-center gap-6 mt-4">
                    {/* <button
                      onClick={() => handleLike(item.commentId, item.likes)}
                      className="text-blue-600 font-medium flex items-center gap-1"
                    >
                      {/* 👍 {item.likes.length}  <AiFillLike size={22}/>

                    </button> */}
                    <button
                      onClick={() => handleLike(item.id, item.likes ?? [])}
                    >
                      ❤️ {(item.likes ?? []).length}
                    </button>

                    <button
                      onClick={() =>
                        setReplyingTo(
                          replyingTo === item.commentId ? null : item.commentId
                        )
                      }
                      className="text-gray-600 font-medium flex items-center gap-1"
                    >
                      💬 Reply
                    </button>
                  </div>

                  {/* REPLY INPUT (only show if replying) */}
                  {replyingTo === item.commentId && (
                    <div className="mt-4 pl-10">
                      <textarea
                        value={replyText}
                        onChange={(e) => setReplyText(e.target.value)}
                        placeholder="Write a reply..."
                        className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500"
                        rows="2"
                      />

                      <button
                        onClick={() => handleReply(item.commentId, replyText)}
                        className="bg-green-600 hover:bg-green-700 text-white px-4 py-1 rounded-lg mt-2"
                      >
                        Post Reply
                      </button>
                    </div>
                  )}

                  {/* REPLIES */}
                  {(item.replies ?? []).length > 0 && (
                    <div className="mt-5 pl-10 border-l-2 border-gray-300 space-y-4">
                      {item.replies.map((r, i) => (
                        <div key={i} className="flex gap-3">
                          {/* <img
                            alt="avatar"
                            src={r.avatar}
                            className="w-10 h-10 rounded-full border object-cover"
                          /> */}
                          <div>
                            <h6 className="font-semibold text-gray-900">
                              {r.username || "Anonymous"}
                            </h6>
                            <p className="text-gray-700 text-2xl leading-relaxed">
                              {r.replyText}
                            </p>

                            <p className="text-gray-500 text-xs">
                              {new Date(r.createdAt).toLocaleString()}
                            </p>
                          </div>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BlogDescription;
